import React from 'react';
import {Link} from 'react-router-dom';
import {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import axiosServise from '../ApiService';
import axios from 'axios';
// import './HolyQuranStyle.scss';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import './Mafatih.scss'
function MafatihContent() {

    const [mafateehContent, setmafateehContent] = useState([]);
    const [mafateehPartName, setmafateehPartName] = useState('');
    const {id} = useParams();
    const PrayerCategories=localStorage.getItem("PrayerCategories");
    // const countOfSurahID = parseInt(id)
    // const [isLoading, setIsLoading] = useState(false);




    useEffect(() => {
        // setIsLoading(true);
        
        getmafateehContentData()
        //for find mafateehPartName
        debugger
        const findPartName = JSON.parse(PrayerCategories).find((item) => item.code === id)
        setmafateehPartName(findPartName.name)
    }, [setmafateehContent, setmafateehPartName])

    const getmafateehContentData = () => {
        axiosServise.get(`Prayers/${id}`).then(response => {
            const data = response.data.content;
            setmafateehContent(data)
            console.log(data);
            // setIsLoading(false)
        }).catch(error => {

        });
    }

    return (<>
        <div className='third-base pt-md-5' style={{paddingBottom: '60px'}}>
            {/* <div className='player-container col-12'>
                <AudioPlayer className='col-11 col-md-5'
                             src="http://khorshidpishva.com:8080/api/FileManager/GetAlFatihaAudio/"
                             onPlay={e => console.log("onPlay")}
                />
            </div> */}
            {/*<div className='topborder'>*/}
            {/*     <span> شروع صفحه </span>*/}
            {/*</div>*/}
            <div className='HolyQuranPage col-11 col-md-9'>
                <div className='section-header col-12 col-md-7 m-auto mb-3'>
                    <div className='nameOfSure col-12'>
                        {/* <div>
                            <img src={quranBackdrop} alt=""/>
                        </div> */}
                        <h2 style={{fontFamily: 'QuranTaha',margin: "auto",color: "#ffffff"}}>{mafateehPartName}</h2>
                    </div>
                </div>
                <div className='QuranPage-container'>
                    <div className='verse'>
                        <div className='container-Quranpage'>
                            {/* {
                                mafateehPartName === 'حمد' || mafateehPartName ==='توبه' ? <div></div>
                                    : <div className='in-the-name-of-god-verse col-12'>
                                        <div className='col-11'>
                                            <div className='arabic-text' style={{textAlign: 'center'}}>
                                                <span>{inTheNameOfGod.arabicText}</span>
                                            </div>
                                            <div className='persian-text' style={{textAlign: 'center'}}>
                                                <p>{inTheNameOfGod.persianText}</p>
                                            </div>
                                        </div>
                                    </div>
                            } */}
                            {
                                mafateehContent.map((item) => {
                                    return (<div
                                        className={`verse-container col-12 ${item.prayerOrder % 2 === 0 ? "glass-effect" : ""}`}
                                        key={item.id}>
                                        <div className='section-right-text col-11'>
                                            <div className='arabic-text'>
                                                <span>{item.arabic}</span>
                                            </div>
                                            <div className='persian-text'>
                                                <p>{item.translate}</p>
                                            </div>
                                        </div>
                                        <div className='section-left-number-more col-1'>

                                            <div className='numberOf-sure col-12 col-md-6 d-flex'>
                                                <div className='verse-number-icon'>
                                                    {item.prayerOrder}
                                                </div>
                                            </div>

                                            <div className='more-option-sure'>


                                            </div>
                                        </div>
                                    </div>)
                                })}

                        </div>
                    </div>
                </div>
            </div>


        </div>
    </>)
};

export default MafatihContent;
